import {
  GetGroupsAPIResponse,
  PostGroupAPIResponse,
  GroupPayload,
  GetLocalizedGroupsAPIResponse,
  LocalizedGroupPayload,
  PostLocalizedGroupsAPIResponse,
  DeleteLocalizedGroupsAPIResponse,
  GetGroupThemesApiResponse,
  GroupThemeColors,
  PostGroupThemesApiResponse,
  GetNutritionCategoriesAPIResponse,
  NutritionCategory,
  PostNutritionCategoryAPIResponse,
} from "app/types/package";
import axios from "./config";
import { AxiosResponse } from "axios";

export const getGroupListsApi = (
  storeId: number,
  query = "",
): Promise<AxiosResponse<GetGroupsAPIResponse>> =>
  axios.get<GetGroupsAPIResponse>(`/stores/${storeId}/groups${query}`);

type PostGroupApiRequest = {
  storeId: number;
  payload: GroupPayload;
};

export const postGroupApi = ({
  storeId,
  payload,
}: PostGroupApiRequest): Promise<AxiosResponse<PostGroupAPIResponse>> =>
  axios.post<PostGroupAPIResponse>(`/stores/${storeId}/groups`, payload);

type PutGroupApiRequest = {
  storeId: number;
  groupId: number;
  payload: GroupPayload;
};
export const putGroupApi = ({
  storeId,
  groupId,
  payload,
}: PutGroupApiRequest): Promise<AxiosResponse<PostGroupAPIResponse>> =>
  axios.put<PostGroupAPIResponse>(
    `/stores/${storeId}/groups/${groupId}`,
    payload,
  );

// Localization API

type GetLocalizedGroupsApiRequest = {
  storeId: number;
  groupId: number;
  query: string;
};
export const getLocalizedGroupsApi = ({
  storeId,
  groupId,
  query = "",
}: GetLocalizedGroupsApiRequest): Promise<
  AxiosResponse<GetLocalizedGroupsAPIResponse>
> =>
  axios.get<GetLocalizedGroupsAPIResponse>(
    `/stores/${storeId}/groups/${groupId}/localizations${query}`,
  );

export const postLocalizedGroupApi = ({
  storeId,
  groupId,
  payload,
}: {
  storeId: number;
  groupId: number;
  payload: LocalizedGroupPayload;
}): Promise<AxiosResponse<PostLocalizedGroupsAPIResponse>> =>
  axios.post<PostLocalizedGroupsAPIResponse>(
    `/stores/${storeId}/groups/${groupId}/localizations`,
    payload,
  );

export const deleteLocalizedGroupApi = ({
  storeId,
  groupId,
  locale,
}: {
  storeId: number;
  groupId: number;
  locale: string;
}): Promise<AxiosResponse<DeleteLocalizedGroupsAPIResponse>> =>
  axios.delete<DeleteLocalizedGroupsAPIResponse>(
    `/stores/${storeId}/groups/${groupId}/localizations?locale=${locale}`,
  );

export const getGroupsThemeApi = (
  storeId: number,
): Promise<AxiosResponse<GetGroupThemesApiResponse>> =>
  axios.get<GetGroupThemesApiResponse>(`/stores/${storeId}/GroupAppearances`);

export const postGroupsThemeApi = (
  storeId: number,
  payload: GroupThemeColors,
): Promise<AxiosResponse<PostGroupThemesApiResponse>> =>
  axios.post<PostGroupThemesApiResponse>(
    `/stores/${storeId}/GroupAppearances`,
    payload,
  );
export const putGroupsThemeApi = (
  storeId: number,
  payload: GroupThemeColors,
  themeId: number,
): Promise<AxiosResponse<PostGroupThemesApiResponse>> =>
  axios.put<PostGroupThemesApiResponse>(
    `/stores/${storeId}/GroupAppearances/${themeId}`,
    payload,
  );

export const deleteGroupsThemeApi = (storeId: number, themeId: number) =>
  axios.delete(`/stores/${storeId}/GroupAppearances/${themeId}`);

// Nutrition Categories API
export const getNutritionCategoriesApi = (
  storeId: number,
  query = "",
): Promise<AxiosResponse<GetNutritionCategoriesAPIResponse>> =>
  axios.get<GetNutritionCategoriesAPIResponse>(
    `/stores/${storeId}/nutrition-categories${query}`,
  );

// exclude id from payload
export const postNutritionCategoryApi = (
  storeId: number,
  payload: Omit<NutritionCategory, "id">,
): Promise<AxiosResponse<PostNutritionCategoryAPIResponse>> =>
  axios.post<PostNutritionCategoryAPIResponse>(
    `/stores/${storeId}/nutrition-categories`,
    payload,
  );

export const putNutritionCategoryApi = (
  storeId: number,
  payload: NutritionCategory,
): Promise<AxiosResponse<PostNutritionCategoryAPIResponse>> =>
  axios.put<PostNutritionCategoryAPIResponse>(
    `/stores/${storeId}/nutrition-categories/${payload.id}`,
    payload,
  );
